// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vrKBc","col":"styles_col__33VCx"};